import {svgIconWrapper} from '../svg-icon-wrapper';

import GlobeDomainRegular from './globe-domain-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <GlobeDomainRegular {...props} />;
}
SvgComponent.iconName = 'globeDomainRegular';

export const GlobeDomainRegularIcon = svgIconWrapper(SvgComponent);
